import UICheckbox from 'UIComponents/input/UICheckbox';
import { View } from 'foundations-components/components/View';
import { useCallback, useState } from 'react';
import { List as ImmutableList } from 'immutable';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
// @ts-expect-error untyped module
import ConnectedAPIDropdown from 'customer-data-reference-ui-components/connector/ConnectedAPIDropdown';
import { ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES } from 'automation-ui-canvas/reference-resolvers/types';
import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { ILS_GOALS_MIGRATION } from 'automation-ui-canvas/constants/Gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_SUPPRESSION_LISTS = 20;
const SuppressionListControl = ({
  readOnly,
  classicEnrollmentSettings,
  suppressionLists,
  flow,
  onChange
}) => {
  var _suppressionLists$val, _classicEnrollmentSet;
  const trackEvent = useTrackEvent();
  const isUngatedForIlsGoals = useIsUngated(ILS_GOALS_MIGRATION);
  const clsSuppressionListIds = (classicEnrollmentSettings === null || classicEnrollmentSettings === void 0 ? void 0 : classicEnrollmentSettings.suppressionListIds) || ImmutableList();
  const ilsSuppressionListIds = (suppressionLists === null || suppressionLists === void 0 || (_suppressionLists$val = suppressionLists.value) === null || _suppressionLists$val === void 0 ? void 0 : _suppressionLists$val.map(list => list.listId)) || ImmutableList();
  const suppressionListIds = isUngatedForIlsGoals ? ilsSuppressionListIds : clsSuppressionListIds;
  const [isEditingSuppressionList, setIsEditingSuppressionList] = useState(suppressionListIds.size > 0);
  const [showSelectionError, setShowSelectionError] = useState(false);
  const value = suppressionListIds ? suppressionListIds.map(id => String(id)).toJS() : [];
  const overLimit = suppressionListIds.size > MAX_SUPPRESSION_LISTS;
  let validationMessage;
  if (showSelectionError) {
    validationMessage = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "settings.suppressionSetting.errorMessage.underTwenty"
    });
  } else if (overLimit) {
    validationMessage = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "settings.suppressionSetting.errorMessage.overTwenty"
    });
  }
  const dropdownProps = Object.assign({
    referenceObjectType: isUngatedForIlsGoals ? ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.INBOUND_DB_LISTS : ALL_SUPPORTED_REFERENCE_RESOLVER_TYPES.CONTACT_LIST
  }, isUngatedForIlsGoals && {
    requestOptions: {
      listFilterProperties: {
        objectTypeId: '0-1'
      }
    }
  });
  const handleOnChange = useCallback(newValue => {
    if (isUngatedForIlsGoals) {
      onChange({
        suppressionLists: {
          value: ImmutableList(newValue.map(listId => {
            return {
              listId,
              listTypes: ['SUPPRESSION_LIST']
            };
          }))
        }
      });
    } else {
      onChange({
        classicEnrollmentSettings: classicEnrollmentSettings === null || classicEnrollmentSettings === void 0 ? void 0 : classicEnrollmentSettings.set('suppressionListIds', newValue)
      });
    }
  }, [onChange, isUngatedForIlsGoals, classicEnrollmentSettings]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UICheckbox, {
      size: "small",
      readOnly: readOnly,
      checked: readOnly ? Boolean(suppressionListIds.size) : isEditingSuppressionList,
      onChange: ({
        target: {
          checked
        }
      }) => {
        setIsEditingSuppressionList(checked);
        trackEvent(Trackables.WORKFLOW_SETTINGS_INTERACTION, {
          subAction: 'suppressionLists'
        });
        handleOnChange(ImmutableList([]));
      },
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "settingsV2.enrollmentNotificationSetting.classicUnenrollment.suppression_cob",
        objectTypeId: flow.objectTypeId
      })
    }), (readOnly && Boolean(classicEnrollmentSettings === null || classicEnrollmentSettings === void 0 || (_classicEnrollmentSet = classicEnrollmentSettings.suppressionListIds) === null || _classicEnrollmentSet === void 0 ? void 0 : _classicEnrollmentSet.size) || !readOnly && isEditingSuppressionList) && /*#__PURE__*/_jsx(View, {
      margin: "300",
      children: /*#__PURE__*/_jsx(ConnectedAPIDropdown, Object.assign({}, dropdownProps, {
        onChange: ({
          target: {
            value: newValue
          }
        }) => {
          trackEvent(Trackables.WORKFLOW_SETTINGS_INTERACTION, {
            value,
            subAction: 'suppressionLists'
          });
          if (newValue.length <= Math.max(MAX_SUPPRESSION_LISTS, suppressionListIds.length // wrong type but don't want to change existing behavior
          )) {
            setShowSelectionError(false);
            handleOnChange(ImmutableList(newValue.map(listId => {
              return Number(typeof listId === 'object' ? listId.value : listId);
            })));
          } else {
            setShowSelectionError(true);
          }
        },
        value: value,
        error: overLimit || showSelectionError,
        validationMessage: validationMessage,
        multi: true,
        placeholder: I18n.text('settings.suppressionSetting.placeholder'),
        readOnly: readOnly,
        multiCollapseLimit: 10,
        "data-test-id": "platform-settings-supression-list-select"
      }))
    })]
  });
};
export default SuppressionListControl;